import Layout from "@/components/layout";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import PrivyProviders from "@/providers/privy-provider";
import Auth from "@/modules/auth";

export const Route = createFileRoute("/_public/_layout")({
  component: MainLayout,
});

function MainLayout() {
  return (
    <PrivyProviders>
      {/* <Auth> */}
        <Layout>
          <Outlet />
        </Layout>
      {/* </Auth> */}
    </PrivyProviders>
  );
}
